export default {
    cptDataForm: {
        dataText: '[]',
        dataSource: 1,
        pollTime: 0,
    },
    attribute: {
        trigger: 'hover',
        fit: 'cover',
        imgUrls: [],
        isShowNavbar: 1,
        defaultNumber: 1,
        spaceBetween: 1,
        defaultSelectedIndex: 0,
        selecedBorderColor: 'transparent',
        autoPlay: true,
        cptTableData: [
            { "name": "图片", "value": "", "namekey": "value" },
            { "name": "文本", "value": "", "namekey": "label" },
        ]
    },
    interaction: { intType: 'none' }
}